import { config } from "@/lib/config";
import { createQueryString } from "@/utils";

export const saveContactUsForm = async (pageData: any) => {
  try {
    const res = await fetch("/api/saveContactUsForm", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pageData),
    });

    if (!res.ok) throw new Error("Failed to save contact form");

    return res.json();
  } catch (error) {
    throw error;
  }
};

interface RegisterEventFormDataInterface {
  firstname: string;
  lastname: string;
  email: string;
  gender: string;
  country: string;
  role_job_title: string;
  organization: string;
  type_of_organization: string;
}

export const saveRegisterEventFormData = async (
  pageData: RegisterEventFormDataInterface,
) => {
  try {
    const res = await fetch("/api/saveRegisterEventFromData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pageData),
    });

    if (!res.ok) throw new Error("Failed to save event registration");

    return res.json();
  } catch (error) {
    throw error;
  }
};

export const getTrainingPaginatedData = async (query: any) => {
  try {
    const queryString = createQueryString(query);

    const res = await fetch(`/api/getTrainingPaginatedData${queryString}`);

    if (!res.ok) throw new Error("Failed to fetch training data");

    return res.json();
  } catch (error) {
    throw error;
  }
};

export const getFilteredToolData = async ({
  sector = [],
  region = [],
  category = [],
  explore = false,
}: {
  sector?: string | string[];
  region?: string | string[];
  category?: string | string[];
  explore?: boolean;
}) => {
  try {
    const queryString = createQueryString({
      sector,
      region,
      category,
      explore,
    });

    const res = await fetch(`/api/toolData${queryString}`);

    if (!res.ok) throw new Error("Failed to fetch filtered tool data");

    return res.json();
  } catch (error) {
    throw error;
  }
};

export const getJoinFormData = async () => {
  try {
    const res = await fetch(`${config.apiBase}/api/webform/submissions`);

    if (!res.ok) throw new Error("Failed to fetch join form data");

    return res.json();
  } catch (error) {
    throw error;
  }
};

interface PledgeFormDataInterface {
  webform_id: string | undefined;
  first_name: string;
  last_name: string;
  email: string;
  pledge_type: string;
  pledge_position: string;
  organization_name: string;
  website_link: string;
  selected_pledges: string;
  custom_commitment: string;
  pledge_actions: string;
  pledge_commitment: string;
  pledge_goals: string;
  selected_sector: string;
  specific_actions: string;
  direct_investment: string;
  organization_logo: string;
}

export const savePledgeFormData = async (pageData: PledgeFormDataInterface) => {
  try {
    const response = await fetch("/api/savePledgeFormData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pageData),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

interface ElevatePageFormDataInterface {
  webform_id: string | undefined;
  name: string;
  email: string;
  age: string;
  gender: string;
  country: string;
}

export const saveElevatePageFormData = async (
  pageData: ElevatePageFormDataInterface,
) => {
  try {
    const response = await fetch("/api/saveElevatePageFormData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pageData),
    });
    return response;
  } catch (error) {
    throw error;
  }
};